import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  MenuItem,
  styled,
  Typography,
} from '@mui/material';

const StyledHome = styled(Box)(({ theme }) => ({
  margin: '39px 24px 0 24px',
  display: 'flex',
  gap: '8px',
  paddingBottom: '20px',
  alignItems: 'center',
  borderBottom: `1px solid ${theme.palette.divider}`,
  userSelect: 'none',
  cursor: 'pointer',
}));

const MenuPaddingLeft = 24;
const MenuPadding = `0px 24px 0px ${MenuPaddingLeft}px`;
const MenuItemHeight = '36px';
const getPaddingLeft = (layers: number) => `${(layers - 1) * MenuPaddingLeft}px`;

const StyledAccordion = styled(Accordion)(({ theme }) => ({
  ':before': { display: 'none' },
  boxShadow: 'none',
}));

const StyledMenuItem = styled(MenuItem)(({ theme }) => ({
  padding: MenuPadding,
  height: MenuItemHeight,
  color: theme.palette.text.secondary,
  '.MuiTypography-root': {
    ...theme.typography.button,
  },
  ':hover': {
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.paper,
  },
  '&.Mui-selected': {
    backgroundColor: theme.palette.background.paper,
    color: theme.palette.primary.main,
    '.MuiTypography-root': {
      ...theme.typography.h6,
    },
    ':hover': {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.background.paper,
    },
  },
}));

const StyledAccordionSummary = styled(AccordionSummary, {
  shouldForwardProp: (prop) => prop !== 'isFirstLayer',
})<{ isFirstLayer: boolean }>(({ theme, isFirstLayer }) => ({
  padding: MenuPadding,
  '& .MuiAccordionSummary-expandIconWrapper': {
    transform: 'rotate(270deg)',
  },
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(360deg)',
  },
  '& .MuiAccordionSummary-content': {
    margin: 'unset',
  },
  ...(!isFirstLayer && {
    color: theme.palette.text.secondary,
    minHeight: MenuItemHeight,
    ':hover': {
      color: theme.palette.text.primary,
    },
  }),
}));

const StyledAccordionDetails = styled(AccordionDetails, {
  shouldForwardProp: (prop) => prop !== 'isFirstLayer' && prop !== 'layers',
})<{ isFirstLayer: boolean; layers: number }>(({ isFirstLayer, layers }) => ({
  padding: '0',
  ...(!isFirstLayer && {
    '& .MuiTypography-root': {
      paddingLeft: getPaddingLeft(layers),
    },
  }),
}));

const StyledVersionNumber = styled(Typography)(() => ({
  padding: '24px',
  userSelect: 'none',
  lineHeight: '225%',
  fontWeight: '300',
}));

export {
  StyledHome,
  StyledAccordion,
  StyledMenuItem,
  StyledAccordionSummary,
  StyledAccordionDetails,
  StyledVersionNumber,
};
